export default {
  loggedInState: false,
  isAuthCodePageVisible: false,
  currentUser: {},
  tempPhoneNumber: ''
}
